<template>
    <ImpedimentContainer
        title="VI-Impedimento Visual"
    >
        <p><b>El estudiante:</b></p>
        <TreeOptions
            v-model="optionsTree"
            :is-disabled="isDisabled"
            :show-error="showErrors && !isValid"
        />
    </ImpedimentContainer>
</template>
  
<script>
import TreeOptions from './options/TreeOptions.vue';
import ImpedimentMixin from './common/ImpedimentMixin';
import ImpedimentContainer from './common/ImpedimentContainer';

export default {
    name: 'ImpedimentoVisual',
    mixins: [ImpedimentMixin],
    components: {
        TreeOptions,
        ImpedimentContainer
    },
    data: () => ({
        showErrors: false,
    }),
    methods: {
        validate() {
            this.showErrors = true;
            return this.isValid;
        }
    },
    computed: {
        isValid() {
            return this.isValidOptionsSelection;
        }
    },
}
</script>